import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blog';

export default function Blog() {
  const navigate = useNavigate();

  const handleReadMore = (id: number) => {
    navigate(`/blog-detail?id=${id}`);
  };

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 border border-gray-300 rounded-full text-xs font-medium text-gray-700 mb-4">
            Latest Insights
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Design Stories & Tips
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Explore our latest articles on design trends, tips, and inspiration to help you create beautiful spaces.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="group cursor-pointer" onClick={() => handleReadMore(post.id)}>
              <div className="relative rounded-2xl overflow-hidden mb-6 h-64">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-900 rounded-full text-xs font-medium">
                    {post.category}
                  </span>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-xs text-gray-600">
                  <span>{post.date}</span>
                  <span>•</span>
                  <span>{post.readTime}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors line-clamp-2">
                  {post.title}
                </h3>

                <p className="text-sm text-gray-600 line-clamp-3">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between pt-4">
                  <div className="flex items-center space-x-3">
                    <img
                      src={post.author.avatar}
                      alt={post.author.name}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-sm font-medium text-gray-900">{post.author.name}</span>
                  </div>

                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReadMore(post.id);
                    }}
                    className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-teal-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
